// Packages
import Vue from 'vue';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/promo/gift.scss';

// Swiper
import Swiper from 'swiper';
import { EffectFade, Navigation as SwiperNavigation } from 'swiper/modules';
Swiper.use([EffectFade, SwiperNavigation]);

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Components
import '~scripts/components/modals';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

//
// HEADER
//
import Header from '~scripts/blocks/header';

Header();

//
// NAVIGATION
//
import Navigation from '~scripts/blocks/navigation';

Navigation();

//
// TARIFFS PROMO
//
// Animation
let stopTariffsPromoAnimation = [];

const handleTariffsPromoAnimation = () => {
  const tariffsPromo = document.querySelectorAll('.js-tariff-promo');

  if (mediaSm.matches) {
    tariffsPromo.forEach((tariffPromo) => {
      scrollAnimationProgress(tariffPromo, {
        getStart(el) {
          const rect = el.getBoundingClientRect();
          return rect.top + window.scrollY - window.innerHeight;
        },
        getEnd(el, start) {
          const height = el.offsetHeight;
          return start + height * 0.725;
        },
      });
    });
  } else {
    stopTariffsPromoAnimation.forEach((stop) => stop());
  }
};

handleTariffsPromoAnimation();
mediaSm.addEventListener('change', handleTariffsPromoAnimation);

// Slider
const tariffsPromoSliderOptions = {
  allowTouchMove: false,
  effect: 'fade',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  noSwiping: true,
  slidesPerView: 1,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  spaceBetween: 0,
};

let tariffsPromoSlider = mediaSm.matches ? new Swiper('#tariffs-promo-slider', tariffsPromoSliderOptions) : null;

const handleTariffsPromoSliderInit = () => {
  if (mediaSm.matches) {
    if (tariffsPromoSlider) {
      tariffsPromoSlider.enable();
      tariffsPromoSlider.destroy();
    }
  } else {
    tariffsPromoSlider = new Swiper('#tariffs-promo-slider', tariffsPromoSliderOptions);
  }
};

handleTariffsPromoSliderInit();
mediaSm.addEventListener('change', handleTariffsPromoSliderInit);

//
// HUNTFLOW HELPS
//
import huntflowHelpsItemsInit from '~scripts/blocks/huntflow-helps-items';

huntflowHelpsItemsInit();

//
// CUSTOMER FEEDBACKS
//
import customerFeedbacksInit from '~scripts/blocks/customer-feedbacks';

customerFeedbacksInit();

//
// REQUEST FORM
//
import initRequestForm from '~scripts/blocks/request-form';

const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// CLIENTS
//
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';

new Vue({
  el: '#VClientsLogotypes',
  name: 'VClientsLogotypes',
  components: {
    ClientsLogotypes,
  },
});

//
// TARIFFS PROMO SLIDER
//
import Price from '~scripts/pages/price/index/vue/Price/Price.vue';

const tariffPromoItems = document.querySelectorAll('.js-tariff-promo');

tariffPromoItems.forEach((item) => {
  new Vue({
    el: item,
    name: 'VPrice',
    components: {
      Price,
    },
  });
});

//
// GIFT MODAL SLIDER
//
import PricingTariffsFeaturesSlider from '~scripts/pages/price/index/vue/PricingTariffsFeatures/PricingTariffsFeaturesSlider.vue';

const giftModalContentItems = document.querySelectorAll('.js-gift-modal-content');

giftModalContentItems.forEach((item) => {
  new Vue({
    el: item,
    name: 'VContent',
    components: {
      PricingTariffsFeaturesSlider,
      Price,
    },
  });
});

// Tabs
const keyFeaturesTabsList = document.querySelectorAll('.js-key-features-tabs');

const keyFeaturesSliderSetActiveTab = (tabs, tab = tabs[0]) => {
  tabs.forEach((tab) => {
    if (tab.classList.contains('is-active')) {
      tab.classList.remove('is-active');
    }
  });

  tab.classList.add('is-active');

  const caret = tabs[0].querySelector('span');
  caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
  caret.style.width = `${Math.floor(tab.offsetWidth)}px`;
};

const handleKeyFeaturesTabsInit = () => {
  // Tabs
  keyFeaturesTabsList.forEach((tabs) => {
    const keyFeaturesTabs = tabs.querySelectorAll('li');

    keyFeaturesTabs.forEach((tab, index) => {
      const tabIndex = index;

      keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab[0]);

      tab.addEventListener('click', (e) => {
        e.preventDefault();

        keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab);

        tariffsPromoSlider.slideTo(tabIndex);
      });
    });

    if (tariffsPromoSlider && !mediaSm.matches) {
      tariffsPromoSlider.on('slideChange', (swiper) => {
        const slideIndex = swiper.realIndex + 1;

        // Tabs
        keyFeaturesTabs.forEach((tab, index) => {
          const tabIndex = ++index;

          if (tabIndex === slideIndex) {
            keyFeaturesSliderSetActiveTab(keyFeaturesTabs, tab);
          }
        });
      });
    }
  });
};

// Resize
const handleKeyFeaturesResize = () => {
  const keyFeaturesTabsList = document.querySelectorAll('.js-key-features-tabs');

  keyFeaturesTabsList.forEach((tabs) => {
    const keyFeaturesTabs = tabs.querySelectorAll('li');

    const caret = keyFeaturesTabs[0].querySelector('span');

    keyFeaturesTabs.forEach((tab) => {
      if (tab.classList.contains('is-active')) {
        caret.style.transform = `translateX(${Math.floor(tab.offsetLeft)}px)`;
        caret.style.width = Math.floor(tab.offsetWidth) + 'px';
      }
    });
  });
};

handleKeyFeaturesTabsInit();
mediaSm.addEventListener('change', handleKeyFeaturesTabsInit);

window.addEventListener('resize', handleKeyFeaturesResize);

let giftButton = document.querySelectorAll('.js-gift-modal-button');
let giftModal = document.querySelectorAll('.gift-modal');

giftButton.forEach((button) => {
  button.addEventListener('click', () => {
    giftModal.forEach((modal) => {
      if (modal.classList.contains('modal--open')) {
        setTimeout(() => {
          modal.classList.remove('modal--open');
        }, 300);
      }
    });
  });
});
